import { useMemo } from 'react';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Icon, IconName, Timeline } from '@carbonify/ui';
import InlineRichText from 'components/RichContent/InlineRichText';

interface TimelineBlockRecord extends CdaStructuredTextRecord {
  items: { title: string; subtitle: string; icon?: IconName }[];
}

export default function TimelineBlock({ items }: TimelineBlockRecord) {
  const timelineItems = useMemo(
    () =>
      items.map(({ title, subtitle, icon }) => ({
        title,
        description: <InlineRichText>{subtitle}</InlineRichText>,
        icon: icon ? <Icon name={icon} /> : undefined,
      })),
    [items],
  );

  return <Timeline items={timelineItems} />;
}
